<!----------------------- Сторінка підтвердження пошти --------------------->
<template>
    <div>
        <headloginreg />
        <div class="container">
            <div class="alert alert-danger">
                <h5>{{ lang['MailNotVerifiedLinkTimedOut'] }}</h5>
            </div>
            <div class="buttonLogin">
                <button class="btn btn-outline-success" @click="goLogin()">{{ lang['Next'] }}</button>
            </div>
        </div>
    </div>
</template>

<script>
/**
    Cтраница подтверждения почты
 */
import headloginreg from './heads/HeaderLoginAndReg.vue'; //Компонент хедеру з логотипом
export default {
  components: {
    headloginreg
  },
  created() {
    const url = window.location.href;
    const linkParams = (new URL(url)).searchParams;
    // повертаємо об'єкт у якому поміщаємо видерті з посилання значення
    const l = linkParams.get('lang');
    console.log(l);
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang;
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.btn-outline-success {
    width: 100%;
}

.buttonLogin {
    text-align: center;
}

.container {
    margin-top: 10px;
}
</style>